import { render, staticRenderFns } from "./ValuationStep.vue?vue&type=template&id=a45285fa&scoped=true&"
import script from "./ValuationStep.vue?vue&type=script&lang=ts&"
export * from "./ValuationStep.vue?vue&type=script&lang=ts&"
import style0 from "./ValuationStep.vue?vue&type=style&index=0&id=a45285fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a45285fa",
  null
  
)

export default component.exports